<template lang="pug">
section.list-checkbox.flex(
  :id="'listCheckboxVue'+Math.random()",
  :class="{ 'flex-col items-start pt-3': direction == 'column', 'items-center flex-wrap w-full' : direction !== 'column' }"
)
  UiCheckbox(
    v-for="(item, index) in list",
    :key="item.ID",
    v-model="activeCheckboxes",
    :input-value="item.ID",
    @input="callback(item.ID, index)",
    large,
    :class=`['list-checkbox__item', {
      'mr-10 mb-3': (index < list.length) && direction != 'column',
      'mt-3': index < (list.length) && direction === 'column',
      'items-center': direction !== 'column'
    }]`) {{ item.NAME ? item.NAME : item.ID }}
</template>

<script>
import UiCheckbox from '@/components/ui/UiCheckbox.vue'

export default {
  name: 'ListCheckbox',
  props: {
    direction: String,
    list: Array,
    checkedProp: String,
  },
  components: { UiCheckbox },
  data() {
    return {
      activeCheckboxes: [],
    }
  },
  methods: {
    callback(id) {
      if (this.activeCheckboxes.includes(id)) {
        const index = this.activeCheckboxes.indexOf(id)
        this.activeCheckboxes.splice(index, 1)
      } else {
        this.activeCheckboxes.push(id)
      }
      this.$emit('callbackCheckboxes', this.activeCheckboxes)
    },
  },
  mounted() {
    if (this.checkedProp !== undefined) this.callback(this.checkedProp)
  },
}
</script>
